import React, { Component } from 'react'
import { Button, Modal, Upload, Radio, message } from 'antd'
import * as XLSX from 'xlsx'
import './index.less'
import http from '../../../../utils/fetch'
import * as API from '../../../../api'
import {isString, isNumber} from '../../../../utils'

interface IState {
	fileList: any,
	fileListWait: any,
	importLoading: boolean,
	fileListName: any
}
class Batchimport extends Component<any,IState> {
	state = {
		fileList: [], // 本地选择 删除多余文件后的文件
		fileListWait: [], // 本地选择 文件夹内所有的文件
		fileListName: [], // 本地选择 删除多余文件后的文件的文件名
		lackFile: [], // 本地选择 excel里有 但缺少的文件
		commitJson: [], // 开始导入的json
		importType: '', // 上传的类型 （网络连接集合0 or 本地选择1)
		importLoading: false,
		radioDisabled: [{ // 上传的类型 置灰展示
			disable: false,
			name: ''
		},{
			disable: false,
			name: ''
		}]
	}
	hideImport() {
		this.props.hideImport()
		this.setState({
			fileList: [], // 本地选择 删除多余文件后的文件
			fileListWait: [], // 本地选择 文件夹内所有的文件
			fileListName: [], // 本地选择 删除多余文件后的文件的文件名
			lackFile: [], // 本地选择 excel里有 但缺少的文件
			commitJson: {}, // 开始导入的json
			importType: '', // 上传的类型 （网络连接集合0 or 本地选择1)
			radioDisabled: [{ // 上传的类型 置灰展示
				disable: false,
				name: ''
			},{
				disable: false,
				name: ''
			}]
		})
	}
	async startImport () {
		const { commitJson, lackFile, fileList } = this.state
		const that = this
		const promise = []
		let importSucces = true
		if(lackFile.length > 0) {
			return
		}
		let isUploadSucess = true
		for(let i = 0; i < fileList.length; i++) {
			if(fileList[i].state !== '上传成功') {
				isUploadSucess= false
				break
			}
		}
		console.log('isUploadSucess',fileList,isUploadSucess);
		if(!isUploadSucess || fileList.length === 0 || commitJson.length === 0) return
		this.setState({
			importLoading: true
		})
		const nameMap = await JSON.parse(localStorage.getItem('contentTypeNameMap'))
		console.log('commitJson',commitJson)
		commitJson.forEach((item, index) => {
			//第一条是标题
			if(index !== 0) {
				item['is_del'] = '0'
				if(isString(item.st_type)) {
					item.st_type = nameMap[item.st_type]
				}
				promise.push(this.importPromise(item))
			}
		})
		Promise.all(promise).then(res => {
			res.forEach(item => {
				if(item.code !== 0) {
					importSucces = false
				}
			})
			this.setState({
				importLoading: false
			})
			if(importSucces) {
				message.success('导入成功')
				this.hideImport()
				that.props.getContentList()
			} else {
				message.error('导入失败,请检查excel表必填数据')
			}
		})
	}
	importPromise = (item: object) => {
		return new Promise((resolve) => {
			API.addContent(item).then(res => {
				resolve(res)
			})
		})
	}
	// 读取excel
	onImportExcel = (file: any) => {
		return new Promise((resolve, reject) => {
			// 通过FileReader对象读取文件
			const fileReader = new FileReader()
			fileReader.onload = event => {
				try {
					const result = event.target ? event.target.result : null
					// 以二进制流方式读取得到整份excel表格对象
					const workbook = XLSX.read(result, { type: 'binary' })
					let data: any[] =[]   // 存储获取到的数据
					for (const sheet in workbook.Sheets) {
						// eslint-disable-next-line no-prototype-builtins
						if (workbook.Sheets.hasOwnProperty(sheet)) {
							// 利用 sheet_to_json 方法将 excel 转成 json 数据
							data = data.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]))
						}
					}
					resolve(data)
				} catch (e) {
					reject('文件类型不正确')
					return
				}
			}
			// 以二进制方式打开文件
			fileReader.readAsBinaryString(file)
		})

	}
	// 选择类型
	changeImportType(e: object) {
		this.uploadBtnClick(e.target.value)
	}
	// 选择类型 后置灰操作
	uploadBtnClick(val: number) {
		let { radioDisabled } = this.state
		const importType = val
		if(importType === 0){
			radioDisabled[0].disable = false
			radioDisabled[1].name = ''
			radioDisabled[1].disable = true
		} else {
			radioDisabled[0].disable = true
			radioDisabled[0].name = ''
			radioDisabled[1].disable = false
		}
		this.setState({
			importType,
			radioDisabled,
			fileList: [],
			fileListWait: [],
			lackFile: []
		})
	}
	tryAgain(fileData,index) {
		const { fileList } = this.state
		const that = this
		console.log('tryAgain',fileData)
		const myform = new FormData()
		myform.append('file',fileData.file)
		fileList[index]['state'] = '上传中...'
		that.setState({
			fileList
		})
		http.post('infoManage/addFile',{
			formData: true,
			body: myform
		}).then(res => {
			if(res.code === 0) {
				fileList[index]['url'] = res.data
				fileList[index]['state'] = '上传成功'
			} else {
				fileList[index]['url'] = ''
				fileList[index]['state'] = '上传失败'
			}
		}).catch(() => {
			fileList[index]['url'] = ''
			fileList[index]['state'] = '上传失败'
		}).finally(() => {
			that.setState({
				fileList
			})
		})
	}
	fileListNode() {
		const { fileList } = this.state
		if(fileList.length > 0) {
			return (
				<div className="fileList">
					{
						fileList.map((item: object, index: number) => {
							return (
								<div key={item.file.name}>
									<span className="name">{item.file.name}</span>
									{item.state === '上传失败' &&
										<span className="try-again" onClick={this.tryAgain.bind(this,item,index)}>重试</span>
									}
									<span className={`state ${item.state === '上传中...' ? 'state-uploading' : ''}`}>{item.state}</span>
								</div>
							)
						})
					}
				</div>
			)
		}
	}
	uploadFiles() {
		const { fileList, commitJson } = this.state
		const that = this
		let promise =[]
		let flag = false
		console.log('uploadFiles',fileList, commitJson)
		// data检查
		for(let i = 0; i < commitJson.length; i++) {
			if(i !== 0) {
				console.log(commitJson[i].st_text_title.length)
				// 文件名
				if(commitJson[i].st_text_title.length > 30) {
					message.error('标题不能大于30字')
					flag = true
					break
				}
				// 时间判断
				if(commitJson[i].st_authorize_date_s) {
					if(
						!/^(\d{4})\[-|.|\/](\d{2})\[-|.|\/](\d{2})$/.test(commitJson[i].st_authorize_date_s)
					) {
						message.error('有效期格式为YYYY.MM.DD')
						flag = true
						break
					} else if(isNumber(commitJson[i].st_authorize_date_s)) {
						message.error('有效期格式为YYYY.MM.DD')
						flag = true
						break
					} else {
						commitJson[i].st_authorize_date_s = commitJson[i].st_authorize_date_s.replace(/\.|\//g, '-')
					}
				}
				// 文件类型判断
				if(
					(commitJson[i].st_type === '图片' && !['jpg', 'png', 'gif'].includes(commitJson[i].st_file_src.split('.').pop().toLowerCase())) ||
					(commitJson[i].st_type === '视频' && !['avi', 'mov', 'rmvb', 'rm', 'flv', 'mp4', '3gp'].includes(commitJson[i].st_file_src.split('.').pop().toLowerCase())) ||
					(commitJson[i].st_type === '音频' && !['mp3','wav','flc'].includes(commitJson[i].st_file_src.split('.').pop().toLowerCase()))
				) {
					message.error('请检查文件类型')
					flag = true
					break
				}
			}
		}
		console.log('flag',flag,fileList)
		if(flag) return

		fileList.map((item, index) => {
			console.log(item, flag)
			promise.push(this.uploadPromise(item.file, index))
		})
		Promise.all(promise).then(() => {
			// 全部上传完成
			// 将excel里的图片名称缓存服务器的url
			commitJson.map(json => {
				// TODO fileList为空？？
				fileList.map(item => {
					Object.keys(json).map((key)=>{
						if(json[key] === item.file.name) {
							if(key === 'st_file_src') {
								json['st_fileurl'] = item.url
								json[key] = item.file.webkitRelativePath
							} else {
								json[key] = item.url
							}
						}
					})
				})
			})
			console.log('commitJson', commitJson)
			that.setState({commitJson})
		})
	}
	uploadPromise(file: object, index: number) {
		const { fileList } = this.state
		const that = this
		return new Promise((resolve, reject) => {
			const myform = new FormData()
			myform.append('file',file)
			fileList[index]['state'] = '上传中...'
			that.setState({
				fileList
			})
			http.post('infoManage/addFile',{
				formData: true,
				body: myform
			}).then(res => {
				if(res.code === 0) {
					fileList[index]['url'] = res.data
					fileList[index]['state'] = '上传成功'
				} else {
					fileList[index]['url'] = ''
					fileList[index]['state'] = '上传失败'
				}
			}).catch(() => {
				fileList[index]['url'] = ''
				fileList[index]['state'] = '上传失败'
			}).finally(() => {
				that.setState({
					fileList
				})
				resolve()
			})
		})
	}
	render() {
		const { fileList, lackFile, importType, radioDisabled } = this.state
		const { showImport } = this.props
		const radioStyle = {
			display: 'block',
			height: '30px',
			lineHeight: '30px',
		}
		// 网络连接集合
		const props2 = {
			showUploadList: false,
			withCredentials: true,
			accept: '.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			name: 'file',
			action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
			headers: {
				authorization: 'authorization-text',
			},
			beforeUpload: (file: any) => {
				console.log(file);
				if(file.name.indexOf('.xls') > 0) {
					radioDisabled[0].name = file.name
					this.onImportExcel(file).then((excelData: any) => {
						// 字段名
						const st = excelData.splice(0,1)[0]
						console.log('excelData', excelData)
						// console.log('st',st)
						// 组合对象
						const st_key = Object.keys(st)
						const commitJson = []
						excelData.map(item => {
							let obj = {}
							st_key.map(key => {
								if(item[key]) {
									if(st[key].indexOf('ai_') > -1) {
										obj['st_tag'] = {}
										obj['st_tag'][st[key]] = item[key]
									} else {
										obj[st[key]] = item[key]
									}
								}
							})
							if(JSON.stringify(obj) !== '{}') commitJson.push(obj)
						})
						this.setState({
							commitJson,
							radioDisabled
						})
						// console.log('commitJson',commitJson)
						// TODO  开始上传fileListWait的文件 获取url 添加到commitJson
					})
					return true
				} else {
					this.setState({
						lackFile: ['未找到excel文件']
					})
					return false
				}
			},
			progress: {
				strokeColor: {
					'0%': '#108ee9',
					'00%': '#87d068',
				},
				strokeWidth: 3,
				format: percent => `${parseFloat(percent.toFixed(2))}%`,
			},
			fileList,
		}
		// 文件夹
		const props = {
			showUploadList: false,
			withCredentials: true,
			accept: 'image/jpeg,image/png,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,video/mp4,video/mp3,video/wmv,video/mov,video/avi',
			onRemove: (file: any) => {
				this.setState(state => {

				})
			},
			name: 'file',
			customRequest: (data) => {
				// console.log('req',data)
				// console.log('fileList',fileList)
			},
			beforeUpload: (file: any) => {
				if(file.name.indexOf('.xls') > 0 && file.name.indexOf('.~') > -1) {
					this.setState({
						lackFile: ['excel文件']
					})
					return
				}
				if(file.name.indexOf('.xls') > 0 && file.name.indexOf('.~') < 0) {
					this.onImportExcel(file).then((excelData: any) => {
						// 字段名
						const st = excelData.splice(0,1)[0]
						console.log('excelData', excelData)
						const { fileListWait, fileListName } = this.state
						console.log('st',st)
						// 获取excel里的文件名
						const excelFileName: [] = []
						excelData.forEach((item: object) => {
							for ( const p in item ){ // 方法
								const val = item[p] + ''
								if(val.indexOf('.') > 0 && st[p] === 'st_file_src') {
									// console.log(item,p)
									console.log(val)
									excelFileName.push(val)
								}
							}
						})
						//缺少文件
						const lackFile = []
						excelFileName.map(item => {
							if(fileListName.indexOf(item) < 0) {
								lackFile.push(item)
							}
						})
						// 多余文件
						const surFile = []
						fileListName.map(item => {
							if(excelFileName.indexOf(item) < 0 && item.indexOf('.xls') < 0) {
								surFile.push(item)
								fileListWait.forEach((m, i) => {
									if(m.file.name === item) {
										fileListWait.splice(i,1)
									}
								})
							}
						})
						console.log('lackFile 缺少文件',lackFile)
						console.log('surFile 多余文件',surFile)
						console.log('excelFileName',excelFileName)
						console.log('fileListName', fileListName)
						console.log('fileListWait', fileListWait,this.state.fileListWait)
						this.setState(state => ({
							fileList: state.fileListWait,
						}))
						// 组合对象
						try{
							const st_key = Object.keys(st)
							const commitJson = []
							excelData.map(item => {
								let obj = {}
								st_key.map(key => {
									if(item[key]) {
										if(st[key].indexOf('ai_') > -1) {
											obj['st_tag'] = {}
											obj['st_tag'][st[key]] = item[key]
										} else {
											obj[st[key]] = item[key]
										}
									}
								})
								if(JSON.stringify(obj) !== '{}') commitJson.push(obj)
							})
							// console.log('commitJson',commitJson)
							radioDisabled[1].name = file.webkitRelativePath.split('/')[0]
							this.setState({
								lackFile,
								commitJson,
								radioDisabled
							})
							// 开始上传fileList的文件 获取url 添加到commitJson
							if(lackFile.length === 0) {
								this.uploadFiles()
							}
						} catch(err) {
							console.log(err)
							message.error('文件夹请保留一个excel文件且关闭编辑中的excel文件再重新上传')

						}

					})
				}
				if(file.name !== '.DS_Store' && file.name.indexOf('.xls') < 0) {
					this.setState(state => ({
						fileListWait: [...state.fileListWait, {file: file, state: '解析成功'}],
						fileListName: [...state.fileListName, file.name],
					}))
				}
				return true
			},
			progress: {
				strokeColor: {
					'0%': '#108ee9',
					'00%': '#87d068',
				},
				strokeWidth: 3,
				format: percent => `${parseFloat(percent.toFixed(2))}%`,
			},
			fileList,
		}
		return (
			<div className="library-wrap">
				<Modal
					className="import-wrap"
					visible={showImport}
					onCancel={this.hideImport.bind(this)}
					title="批量导入"
					footer={[
						<Button key="back" loading={this.state.importLoading} type="primary" onClick={this.startImport.bind(this)}>
							开始导入
						</Button>,
					]}
				>
					<div className="import-content">
						<div className="item">
							<div className="hd download">下载模板</div>
							<div className="bd">
								<span className="left-Tips">为提高导入的成功率,请下载并使用系统提供的模板,并按说明操作。</span>
								<Button type="primary" size="small">
									<a href={`${process.env.REACT_APP_BASE_URL}/infoManage/downloadTemplate`}>下载模板</a>
								</Button>
							</div>
						</div>
						<div className="item">
							<div className="hd upload-file">上传文件</div>
							<div className="bd">
								<Radio.Group onChange={this.changeImportType.bind(this)} value={importType}>
									<Radio
										value={0}
										style={radioStyle}
									>
										<div className={radioDisabled[0].disable ? "disabled item " : "item"}>
											<span className="label">网络连接集合</span>
											<div className="file-area">
												<span className="file-name">{radioDisabled[0].name}</span>
												<Upload {...props2}>
													<Button
														type="primary"
														size="small"
														onClick={this.uploadBtnClick.bind(this,0)}
													>
														选择文件
													</Button>
												</Upload>
											</div>
										</div>
									</Radio>
									<Radio
										value={1}
										style={radioStyle}
									>
										<div className={radioDisabled[1].disable ? 'disabled item' : 'item'}>
											<span className="label">本地选择</span>
											{this.fileListNode()}
											<div className={fileList.length > 0 ? 'file-area uploaded' : 'file-area'}>
												<span className="file-name">{radioDisabled[1].name}</span>
												<Upload
													className="upload"
													{...props}
													directory
												>
													<Button
														type="primary"
														size="small"
														onClick={this.uploadBtnClick.bind(this,1)}
													>
														选择文件夹
													</Button>
												</Upload>
											</div>

										</div>
									</Radio>
								</Radio.Group>
							</div>
						</div>
						<div className="file-tips">
							注意：本地文件夹仅支持.xlsx .xls .mp3 .wav .mp4 .wmv .mov .avi .jpg .png .doc .txt格式的文件，网络链接集合请上传 .xlsx .xls格式的文件
						</div>
						<div className="lack-file">
							{lackFile.length > 0 ? `文件解析失败，${importType === 1 ? `缺少文件：${lackFile}` : `${lackFile}`}`: ''}
						</div>
					</div>
				</Modal>
			</div>
		)
	}
}
export default Batchimport